{
  "familyId": "SPR-KLANK-VERKORTEN",
  "questions": [
    {
      "id": "SPR-KLANK-VERKORTEN-001",
      "familyId": "SPR-KLANK-VERKORTEN",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_klinker_verkorten",
      "questionType": "multiple_choice",
      "question": "Wat is het meervoud van 'maan'?",
      "options": ["manen", "maanen", "mannen", "maan"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "ma-nen",
            "syllables": ["ma", "nen"],
            "types": ["open", "closed"],
            "highlight": [0],
            "label": "Open lettergreep: ma-nen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Open lettergreep",
            "content": "In een open lettergreep (eindigt op een klinker) schrijf je maar één klinker voor de lange klank. Ma-nen: 'ma' is open → één 'a' volstaat.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "open_syllable_aa",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Het meervoud van 'maan' is 'manen'. In een open lettergreep (ma-nen) schrijf je maar één klinker voor de lange klank. De 'aa' wordt 'a' omdat de lettergreep 'ma' open is — hij eindigt op een klinker. Onthoud: open lettergreep = lange klank met één klinker.",
        "solutionSteps": [
          "Maan heeft een lange 'aa'-klank",
          "Meervoud: maan + en = manen",
          "Verdeel in lettergrepen: ma-nen",
          "'Ma' eindigt op een klinker → open lettergreep",
          "Open lettergreep → één klinker volstaat: manen"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Manen' — in de open lettergreep 'ma-' schrijf je maar één 'a'.",
          "1": "Je dacht waarschijnlijk dat je de dubbele klinker moet behouden: 'maanen'. Maar in een open lettergreep (ma-nen) is de klank automatisch lang met één klinker. Onthoud: open lettergreep = één klinker voor de lange klank.",
          "2": "Je dacht waarschijnlijk dat het 'mannen' is. Maar 'mannen' is het meervoud van 'man' (korte 'a'-klank). 'Maan' heeft een lange klank, dus het meervoud is 'manen'. Onthoud: maan → manen (lang), man → mannen (kort).",
          "3": "Je dacht waarschijnlijk dat 'maan' al het meervoud is. Maar 'maan' is enkelvoud (één maan). Het meervoud is 'manen' (meerdere manen). Onthoud: voeg '-en' toe voor het meervoud."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.vowel-doubled-in-open-syllable", "label": "Dubbele klinker behouden in open lettergreep", "optionIndex": 1 },
          { "id": "spr.short-vowel-doubling-confused", "label": "Korte klank verward met lange klank (mannen vs manen)", "optionIndex": 2 },
          { "id": "spr.no-plural-suffix", "label": "Meervoudsuitgang vergeten", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-KLANK-VERKORTEN-002",
      "familyId": "SPR-KLANK-VERKORTEN",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_klinker_verkorten",
      "questionType": "multiple_choice",
      "question": "Welk woord is GOED gespeld?",
      "options": ["boomen", "bommen", "boom", "bomen"],
      "correctAnswer": 3,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "bo-men",
            "syllables": ["bo", "men"],
            "types": ["open", "closed"],
            "highlight": [0],
            "label": "Open lettergreep: bo-men"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Open lettergreep",
            "content": "In een open lettergreep schrijf je maar één klinker. Bo-men: 'bo' is open → één 'o' voor de lange klank.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "open_syllable_oo",
      "variantIndex": 2,
      "citoDifficulty": 0.23,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "'Bomen' is correct. Boom → bomen. In de open lettergreep 'bo-' schrijf je maar één 'o'. De lange klank blijft behouden door de open lettergreep. Onthoud: open lettergreep = één klinker voor de lange klank.",
        "solutionSteps": [
          "Boom heeft een lange 'oo'-klank",
          "Meervoud: boom + en = bomen",
          "Verdeel: bo-men ('bo' is open lettergreep)",
          "Open lettergreep → één klinker: bomen"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je de dubbele klinker moet behouden: 'boomen'. Maar in een open lettergreep (bo-men) is de klank automatisch lang met één klinker. Onthoud: open lettergreep = één klinker.",
          "1": "Je dacht waarschijnlijk dat het 'bommen' is. Maar 'bommen' is het meervoud van 'bom' (korte 'o'-klank, als in een explosie). 'Boom' heeft een lange klank, dus het meervoud is 'bomen'. Onthoud: boom → bomen (lang), bom → bommen (kort).",
          "2": "Je dacht waarschijnlijk dat 'boom' al goed is. Maar de vraag vraagt welk woord goed gespeld is als meervoud. 'Boom' is enkelvoud. Het meervoud is 'bomen'.",
          "3": "Goed! 'Bomen' — open lettergreep 'bo-' houdt de lange klank met één 'o'."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.vowel-doubled-in-open-syllable", "label": "Dubbele klinker behouden in open lettergreep", "optionIndex": 0 },
          { "id": "spr.short-vowel-doubling-confused", "label": "Korte klank verward (bommen vs bomen)", "optionIndex": 1 },
          { "id": "spr.no-plural-suffix", "label": "Enkelvoud als meervoud gezien", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "SPR-KLANK-VERKORTEN-003",
      "familyId": "SPR-KLANK-VERKORTEN",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_klinker_verkorten",
      "questionType": "multiple_choice",
      "question": "Waarom schrijf je 'lopen' met één 'o' en niet 'loopen'?",
      "options": [
        "Omdat de 'o' kort is",
        "Omdat er een medeklinker achter staat",
        "Omdat 'lo' een open lettergreep is — de lange klank blijft vanzelf",
        "Omdat het een werkwoord is"
      ],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "lo-pen",
            "syllables": ["lo", "pen"],
            "types": ["open", "closed"],
            "highlight": [0],
            "label": "Open lettergreep: lo-pen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Waarom één klinker?",
            "content": "In een open lettergreep (eindigt op een klinker) is de klank automatisch lang. Daarom schrijf je maar één klinker: lo-pen, niet loo-pen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "open_syllable_reason",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "In 'lo-pen' is 'lo' een open lettergreep (eindigt op een klinker). In een open lettergreep is de klank automatisch lang, dus je hoeft maar één klinker te schrijven. Daarom schrijf je 'lopen' en niet 'loopen'. Onthoud: open lettergreep = lange klank met één klinker.",
        "solutionSteps": [
          "Verdeel in lettergrepen: lo-pen",
          "'Lo' eindigt op een klinker → open lettergreep",
          "Open lettergreep = klank is automatisch lang",
          "Dus: één klinker volstaat → 'lopen', niet 'loopen'"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat de 'o' kort is. Maar de 'o' in 'lopen' is lang (zoals in 'loop'). In een open lettergreep is de klank automatisch lang, ook met maar één klinker. Onthoud: open lettergreep = lange klank.",
          "1": "Je dacht waarschijnlijk dat de medeklinker erachter de reden is. Maar het gaat om het type lettergreep: open (eindigt op klinker) of gesloten (eindigt op medeklinker). 'Lo-' is open → lange klank met één klinker.",
          "2": "Goed! De open lettergreep 'lo-' houdt de lange klank met maar één 'o'.",
          "3": "Je dacht waarschijnlijk dat de regel alleen voor werkwoorden geldt. Maar de regel geldt voor alle woorden: bomen, manen, lopen, ramen — allemaal open lettergrepen met één klinker. Onthoud: het gaat om de lettergreep, niet om de woordsoort."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.short-vowel-confused", "label": "Denkt dat de o kort is", "optionIndex": 0 },
          { "id": "spr.consonant-causes-long-vowel", "label": "Denkt dat medeklinker de lange klank veroorzaakt", "optionIndex": 1 },
          { "id": "spr.word-class-determines-rule", "label": "Denkt dat woordsoort de regel bepaalt", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-KLANK-VERKORTEN-004",
      "familyId": "SPR-KLANK-VERKORTEN",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_klinker_verkorten",
      "questionType": "multiple_choice",
      "question": "Wat is het meervoud van 'been'?",
      "options": ["beenen", "benen", "bennen", "been"],
      "correctAnswer": 1,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "be-nen",
            "syllables": ["be", "nen"],
            "types": ["open", "closed"],
            "highlight": [0],
            "label": "Open lettergreep: be-nen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Open lettergreep",
            "content": "In een open lettergreep schrijf je maar één klinker. Be-nen: 'be' is open → één 'e' voor de lange klank.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "open_syllable_ee",
      "variantIndex": 4,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "'Benen' is correct. Been → benen. In de open lettergreep 'be-' schrijf je maar één 'e'. De lange klank blijft behouden door de open lettergreep. Onthoud: open lettergreep = één klinker voor de lange klank.",
        "solutionSteps": [
          "Been heeft een lange 'ee'-klank",
          "Meervoud: been + en = benen",
          "Verdeel: be-nen ('be' is open lettergreep)",
          "Open lettergreep → één klinker: benen"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je de dubbele klinker moet behouden: 'beenen'. Maar in een open lettergreep (be-nen) is de klank automatisch lang met één klinker. Onthoud: open lettergreep = één klinker.",
          "1": "Goed! 'Benen' — open lettergreep 'be-' houdt de lange klank met één 'e'.",
          "2": "Je dacht waarschijnlijk dat het 'bennen' is. Maar 'bennen' zou een korte 'e'-klank geven (als in 'ben'). 'Been' heeft een lange klank, dus het meervoud is 'benen'. Onthoud: been → benen (lang), ben → bennen (kort).",
          "3": "Je dacht waarschijnlijk dat 'been' al het meervoud is. Maar 'been' is enkelvoud (één been). Het meervoud is 'benen' (twee benen). Onthoud: voeg '-en' toe voor het meervoud."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.vowel-doubled-in-open-syllable", "label": "Dubbele klinker behouden in open lettergreep", "optionIndex": 0 },
          { "id": "spr.short-vowel-doubling-confused", "label": "Korte klank verward (bennen vs benen)", "optionIndex": 2 },
          { "id": "spr.no-plural-suffix", "label": "Enkelvoud als meervoud gezien", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-KLANK-VERKORTEN-005",
      "familyId": "SPR-KLANK-VERKORTEN",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_klinker_verkorten",
      "questionType": "fill_in",
      "question": "Schrijf het meervoud van 'raam'. Typ je antwoord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["ramen"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "ra-men",
            "syllables": ["ra", "men"],
            "types": ["open", "closed"],
            "highlight": [0],
            "label": "Open lettergreep: ra-men"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Open lettergreep",
            "content": "In een open lettergreep schrijf je maar één klinker. Ra-men: 'ra' is open → één 'a' voor de lange klank. Dus: ramen, niet raamen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "open_syllable_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Raam → ramen. In de open lettergreep 'ra-' schrijf je maar één 'a'. De lange klank blijft behouden door de open lettergreep. Onthoud: raam heeft een lange 'aa', maar in het meervoud schrijf je maar één 'a' (ra-men).",
        "solutionSteps": [
          "Raam heeft een lange 'aa'-klank",
          "Meervoud: raam + en = ramen",
          "Verdeel: ra-men ('ra' is open lettergreep)",
          "Open lettergreep → één klinker: ramen"
        ]
      }
    },
    {
      "id": "SPR-KLANK-VERKORTEN-006",
      "familyId": "SPR-KLANK-VERKORTEN",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_klinker_verkorten",
      "questionType": "categorize",
      "question": "Sorteer deze meervoudsvormen: welke zijn GOED en welke zijn FOUT gespeld?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Goed gespeld", "Fout gespeld"],
        "items": [
          { "text": "manen", "correctCategory": 0 },
          { "text": "boomen", "correctCategory": 1 },
          { "text": "benen", "correctCategory": 0 },
          { "text": "raamen", "correctCategory": 1 },
          { "text": "lopen", "correctCategory": 0 },
          { "text": "deeken", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Open lettergreep = één klinker", "content": "In een open lettergreep schrijf je de lange klank met één letter:\nma-nen ✓ (niet maa-nen), bo-men ✓ (niet boo-men)\nbe-nen ✓ (niet bee-nen), ra-men ✓ (niet raa-men)\nlo-pen ✓ (niet loo-pen), de-ken ✓ (niet dee-ken)", "icon": "lightbulb" } }
      ],
      "conceptId": "open_syllable_categorize",
      "variantIndex": 6,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "In een open lettergreep schrijf je de lange klank met één letter. Goed: manen, benen, lopen. Fout: boomen (moet bomen zijn), raamen (moet ramen zijn), deeken (moet deken zijn).",
        "solutionSteps": [
          "Verdeel in lettergrepen: open lettergreep → één klinker",
          "Goed: ma-nen, be-nen, lo-pen (één klinker ✓)",
          "Fout: boo-men, raa-men, dee-ken (dubbele klinker ✗)"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-KLANK-VERKORTEN-007",
      "familyId": "SPR-KLANK-VERKORTEN",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_klinker_verkorten",
      "questionType": "true_false_series",
      "question": "Zijn deze beweringen over klinkerverkorting waar of onwaar?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "In een open lettergreep schrijf je de lange klank met één klinker.", "isTrue": true },
          { "text": "Het meervoud van 'boom' is 'boomen'.", "isTrue": false },
          { "text": "'Manen' is het meervoud van 'maan'.", "isTrue": true },
          { "text": "In 'lo-pen' schrijf je twee o's omdat de klank lang is.", "isTrue": false },
          { "text": "De open lettergreep maakt de klank automatisch lang.", "isTrue": true }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Open lettergreep = één klinker", "content": "In een open lettergreep (eindigt op een klinker) is de klank automatisch lang. Daarom schrijf je maar één klinker: bo-men (niet boo-men), ma-nen (niet maa-nen), lo-pen (niet loo-pen).", "icon": "lightbulb" } }
      ],
      "conceptId": "open_syllable_tf",
      "variantIndex": 7,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "In een open lettergreep is de klank automatisch lang, dus je schrijft maar één klinker. Boom → bomen (niet boomen), maan → manen, lopen (niet loopen). De open lettergreep doet het werk — je hoeft geen extra klinker toe te voegen.",
        "solutionSteps": [
          "Stelling 1: Waar ✓ — open lettergreep → één klinker",
          "Stelling 2: Onwaar ✗ — boom → bomen (niet boomen)",
          "Stelling 3: Waar ✓ — maan → manen",
          "Stelling 4: Onwaar ✗ — lo-pen heeft één o (open lettergreep)",
          "Stelling 5: Waar ✓ — open lettergreep = automatisch lang"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-KLANK-VERKORTEN-008",
      "familyId": "SPR-KLANK-VERKORTEN",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_klinker_verkorten",
      "questionType": "error_spotting",
      "question": "Zoek de spelfouten in deze tekst en verbeter ze.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "De boomen in het park zijn groot. We loopen over het pad en zien de blaadjes vallen. De raamen van het huis staan open.",
        "errors": [
          {
            "word": "boomen",
            "position": 1,
            "correction": "bomen",
            "explanation": "Bo-men: open lettergreep → één 'o'. Niet 'boo-men'."
          },
          {
            "word": "loopen",
            "position": 8,
            "correction": "lopen",
            "explanation": "Lo-pen: open lettergreep → één 'o'. Niet 'loo-pen'."
          },
          {
            "word": "raamen",
            "position": 18,
            "correction": "ramen",
            "explanation": "Ra-men: open lettergreep → één 'a'. Niet 'raa-men'."
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Open lettergreep = één klinker", "content": "In een open lettergreep schrijf je de lange klank met één letter:\nbo-men ✓ (niet boo-men)\nlo-pen ✓ (niet loo-pen)\nra-men ✓ (niet raa-men)", "icon": "lightbulb" } }
      ],
      "conceptId": "open_syllable_error_spotting",
      "variantIndex": 8,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Drie fouten: 'boomen' moet 'bomen' zijn (bo-men, open lettergreep → één o), 'loopen' moet 'lopen' zijn (lo-pen → één o), 'raamen' moet 'ramen' zijn (ra-men → één a). In een open lettergreep is de klank automatisch lang met één klinker.",
        "solutionSteps": [
          "Fout 1: boomen → bomen (bo-men, open lettergreep → één o)",
          "Fout 2: loopen → lopen (lo-pen, open lettergreep → één o)",
          "Fout 3: raamen → ramen (ra-men, open lettergreep → één a)",
          "Correct: groot, pad, blaadjes, vallen, huis, open ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-KLANK-VERKORTEN-009",
      "familyId": "SPR-KLANK-VERKORTEN",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_klinker_verkorten",
      "questionType": "matching",
      "question": "Koppel elk enkelvoud aan het juiste meervoud.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "maan", "right": "manen" },
          { "left": "boom", "right": "bomen" },
          { "left": "been", "right": "benen" },
          { "left": "raam", "right": "ramen" },
          { "left": "deur", "right": "deuren" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Klinkerverkorting in meervoud", "content": "Bij een lange klank (aa, oo, ee, uu) schrijf je in het meervoud maar één klinker:\nmaan → manen, boom → bomen, been → benen, raam → ramen.\nUitzondering: 'deur' verandert niet (geen dubbele klinker).", "icon": "lightbulb" } }
      ],
      "conceptId": "open_syllable_matching",
      "variantIndex": 9,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Bij lange klanken (aa, oo, ee) schrijf je in het meervoud maar één klinker: maan → manen, boom → bomen, been → benen, raam → ramen. 'Deur' verandert niet omdat 'eu' geen dubbele klinker is maar een tweeklank.",
        "solutionSteps": [
          "Lange klank → één klinker in open lettergreep",
          "maan → ma-nen, boom → bo-men, been → be-nen, raam → ra-men",
          "deur → deu-ren (tweeklank, geen verandering)"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    }
  ]
}